import { BYTES_IN_KB, STORAGE_UNITS } from '../config';

export const formatStorageSize = (bytes: bigint): string => {
  if (bytes === BigInt(0)) {
    return '0 B';
  }

  const bytesNumber = Number(bytes);

  const unitIndex = Math.min(
    Math.floor(Math.log(bytesNumber) / Math.log(BYTES_IN_KB)),
    STORAGE_UNITS.length - 1,
  );

  const value = bytesNumber / Math.pow(BYTES_IN_KB, unitIndex);
  const formattedValue = value % 1 === 0 ? value.toString() : value.toFixed(1);

  return `${formattedValue} ${STORAGE_UNITS[unitIndex]}`;
};
